import { useQuery } from '@tanstack/react-query'
import { postAsync } from '@/helpers/http-request'

type PasswordStrength = {
  score: number;
  valid: boolean;
}

const useCheckPassword = (userId: string | null, password: string) => {
  const { data, isLoading } = useQuery({
    queryKey: ['checkPassword', userId, password],
    queryFn: async (): Promise<PasswordStrength> => {
      if (!password || password.length === 0) {
        return { score: 0, valid: false }
      }

      const response = await postAsync('/web/v1/user/checkPassword', {
        userId,
        password,
      });

      if (!response.ok) {
        throw new Error('Failed to check password');
      }

      return response.json();
    },
    enabled: !!userId && password.length > 0,
    staleTime: 30000,
  });

  return {
    score: data?.score ?? 0,
    isValid: data?.valid ?? false,
    isLoading,
  };
}

export default useCheckPassword;